export default __webpack_public_path__ + "static/media/pattern.1119a950.png";